var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.content
    ? _c(
        "section",
        { class: _vm.classList },
        [
          _vm.content.background
            ? _c("v-image", {
                staticClass: "content-section__background",
                attrs: {
                  alt: _vm.content.background.alt,
                  tiny: {
                    default: _vm.content.background.default,
                    retina: _vm.content.background.retina
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-section__row row" }, [
            _c("div", { staticClass: "content-section__column column" }, [
              _c(
                "div",
                { staticClass: "content-section__inner" },
                [
                  _c("v-typo", {
                    ref: "headline",
                    staticClass: "content-section__headline",
                    attrs: { variant: "h1" },
                    domProps: { innerHTML: _vm._s(_vm.content.headline) }
                  }),
                  _vm._v(" "),
                  _c("v-typo", {
                    ref: "perex",
                    staticClass: "content-section__perex",
                    attrs: { variant: "body-perex" },
                    domProps: { innerHTML: _vm._s(_vm.content.perex) }
                  }),
                  _vm._v(" "),
                  _vm.content.icon || _vm.content.buttons
                    ? _c(
                        "div",
                        { staticClass: "content-section__buttons" },
                        [
                          _vm.content.icon
                            ? _c("v-icon", {
                                staticClass: "content-section__icon",
                                attrs: { name: _vm.content.icon }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.content.buttons
                            ? _c(
                                "div",
                                {
                                  ref: "buttons",
                                  staticClass: "content-section__button-wrapper"
                                },
                                _vm._l(_vm.content.buttons, function(
                                  button,
                                  buttonIndex
                                ) {
                                  return _c(
                                    "v-button",
                                    {
                                      key: "content-section-" + buttonIndex,
                                      staticClass: "content-section__button",
                                      attrs: {
                                        "on-click": button.onClick
                                          ? button.onClick
                                          : null,
                                        target: button.target
                                          ? button.target
                                          : null,
                                        to: button.to ? button.to : null,
                                        variant: button.variant
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(button.label) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._t("default")
                ],
                2
              )
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }